import './operator-restore-key-page.scss';
import { Loader } from '@ru-digital-assets/ui-component';
import { useParams } from 'react-router';
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'hooks/redux';
import OperatorAPI from 'services/api/Operator';
import { setPush } from 'store/actions/app';
import { IKeyRecoveryInfo, KeyRecoveryStatus } from 'constants/key-recovery';
import PageCard from 'containers/PageCard';
import { useHistory } from 'react-router';
import PageHeader from 'modules/page-header';
import { getFormatedDate } from 'utils';
import cn from 'classnames';
import { KeySelectionFooter } from 'components';
import { showLoader, hideLoader } from 'store/actions/loader';

export default function OperatorRestoreKeyPage() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((s) => s.auth.account.token);
  const [keyInfo, setKeyInfo] = useState<IKeyRecoveryInfo>();

  const updateKeyInfo = useCallback(
    (callback?: () => void) => {
      OperatorAPI.getRecovery(token, +id)
        .then((response) => {
          setKeyInfo(response.data);
        })
        .catch(() => {
          dispatch(
            setPush({
              type: 'error',
              message: 'Не удалось загрузить информацию о заявке на восстановление ключа',
            })
          );
        })
        .finally(callback);
    },
    [id]
  );

  useEffect(() => {
    updateKeyInfo();
  }, [updateKeyInfo]);

  const onClose = useCallback(() => history.push('/history'), []);

  const onSubmitRestoreKey = useCallback(
    (privateKey: string) => {
      dispatch(showLoader());
      OperatorAPI.approveRecovery(token, { recoveryId: +id, privateKey })
        .then(() => {
          dispatch(
            setPush({
              type: 'success',
              message: 'Ключ успешно восстановлен',
            })
          );
          updateKeyInfo(() => {
            dispatch(hideLoader());
          });
        })
        .catch(() => {
          dispatch(
            setPush({
              type: 'error',
              message: 'Ошибка при подтверждении востановления ключа',
            })
          );
          dispatch(hideLoader());
        });
    },
    [id, updateKeyInfo]
  );

  return (
    <div className="operator-restore-key-page">
      <PageHeader
        items={[
          { link: '/history', title: 'Операции' },
          { link: '', title: 'Восстановление Ключей' },
        ]}
        iconType="history"
        isHideBalanceInformer
      />
      {keyInfo ? (
        <PageCard
          title="Восстановление Ключа"
          onClose={onClose}
          minHeight="calc(100vh - 102px)"
          main={
            <div className="operator-restore-key-page__main">
              <p className="p p_bold mb_16">Компания:</p>
              <p className="p p_font-size_18 mb_32">{keyInfo.organizationName}</p>
              <p className="p p_bold mb_16">Пользователь:</p>
              <p className="p p_font-size_18 mb_32">{keyInfo.initiatorName}</p>
              <p className="p p_bold mb_16">Дата инициации восстановления:</p>
              <p className="p p_font-size_18 mb_32">
                {getFormatedDate(keyInfo.lastUpdatedDate, 'dd MMMM yyyy HH:mm')}
              </p>
              <p className="p p_bold mb_16">Статус:</p>
              <div
                className={cn('operator-restore-key-page__status', {
                  'operator-restore-key-page__status_yellow':
                    keyInfo.status === KeyRecoveryStatus.INIT,
                  'operator-restore-key-page__status_green':
                    keyInfo.status === KeyRecoveryStatus.SIGNED,
                })}
              >
                {keyInfo.status === KeyRecoveryStatus.INIT
                  ? 'Заявка на восстановление'
                  : 'Восстановлен'}
              </div>
            </div>
          }
          footer={
            keyInfo.status === KeyRecoveryStatus.INIT ? (
              <KeySelectionFooter
                onBackButtonClick={onClose}
                submitButtonTitle={'Подписать транзакцию\nи восстановить Ключ'}
                onSubmit={onSubmitRestoreKey}
              />
            ) : null
          }
        />
      ) : (
        <div className="flex justify-center mt_32">
          <Loader />
        </div>
      )}
    </div>
  );
}
